import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_left_small",
  "use": "chevron_left_small-usage",
  "viewBox": "0 0 5 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5 6\" id=\"chevron_left_small\"><path d=\"M4 0c.3 0 .5.1.7.3.4.4.4 1 0 1.4L3.4 3l1.3 1.3c.4.4.4 1 0 1.4s-1 .4-1.4 0L.6 3 3.3.3c.2-.2.4-.3.7-.3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol